const messages = {
    pt: {
        translations: {
            btn_access:{
                menu: 'Menu mobile',
                title_en: 'Alterar idioma para inglês',
                title_pt: 'Alterar idioma para português brasileiro'
            },
            ola: {
                ola: 'Olá, meu nome é \n\nAndré Akira'
            },
            dev: {
                front: 'Desenvolvedor Front-end'
            },
            buscar: {
                buscar: "Buscar..."
            },
            nav: {
                sobre: 'Sobre',
                historico: 'Histórico',
                habilidades: "Habilidade",
                portfolio: "Portfólio",
                hobbies: "Hobbies",
                contato: "Contato"
            },
            titles: {
                psobre: 'Apresentação pessoal',
                psobre2: 'Perfil profissional',
                phistorico: 'Histórico profissional',
                phabilidades: 'Habilidades e ferramentas',
            },
            conteudo: {
                psobre: 'Comecei estudando Desenvolvimento de Sistemas no SENAI Informática em agosto de 2019 e desde então tenho me focado na minha formação como desenvolvedor, realizando assim vários cursos em paralelo. Pretendo seguir na área de Desenvolvimento web com Front-end.',
                psobreDisc: {
                    titles: 'DISC - Conformidade',
                    msg: 'Tem ênfase na qualidade, precisão, organização e competência. É cooperativo, sincero e leal. Cauteloso e preocupado. Focado no que é “correto”. Planeja à frente e se preocupa com a precisão. Precavido, preciso, reativo.',
                    btn1: 'Referência',
                    btn2: 'Fechar'
                },
                psobreTeste: {
                    titles: 'Teste Comportamental - Lobo',
                    msg: 'É o organizador. Sempre atento ao planejamento, pontualidade e controle. Detalhista, conservador, metódico, previsível, leal, com dificuldade de adaptação a mudanças e responsável com a realização do combinado ainda são algumas de suas características.',
                    btn1: 'Referência',
                    btn2: 'Fechar'
                },
                psobrePerso: {
                    titles: '16Personalities - Arquiteto INTJ-T',
                    msg: 'É solitário no topo, e sendo um dos tipos de personalidades mais raros e estrategicamente capazes, os Arquitetos estão cientes disso. Os Arquitetos formam apenas dois por cento da população, e as mulheres com esse tipo de personalidade são especialmente raras, formando apenas 0,8% da população – muitas vezes é um desafio para eles encontrarem indivíduos com uma mentalidade semelhante que são capazes de acompanhar seu intelectualismo implacável e manobras de xadrez.',
                    btn1: 'Referência',
                    btn2: 'Fechar'
                }
            },
            cargos: {
                cargo1: 'Estagiário',
                cargo2: 'Desenvolvedor Web',
                cargo3: 'Desenvolvedor Web Designer',
                cargo4: 'Desenvolvedor Web',
                cargo5: 'Desenvolvedor Front-end',
                cargo6: 'Desenvolvedor Pleno',
            },
            duracao: {
                status: 'Trabalhando atualmente ✔️',
                duracaoTempo: "ano",
            },
            tempoExp: "Tempo de experiência: ",
            projetos: {
                titulo: "Trabalhos concluídos",
                botao: "Visite aqui"
            },
            hobbies: {
                titulo: "Hobbies e passatempos",
                game1: "Front-box",
                game2: "Jo-ken-po RPG",
                game3: "Game Memory",
                game4: "Soccer Goal",
                game5: "Bug Swat",
                game6: "Jogo da velha",
                traducao: "Geradores",
                generator1: "Números da Mega Senna",
                generator2: "Gerador Commit Plugin WP",
                generator3: "Gerador de Números",
            },
            contato: {
                titulo: "Curtiu? Entre em contato",
                labels: {
                    nome: "Nome*",
                    email: "E-mail*",
                    assunto: "Assunto*",
                    mensagem: "Mensagem*"
                },
                botao: "Enviar",
                msgs: {
                    enviado: "Enviado com sucesso",
                    erro: "Algo deu errado, tente novamente..."
                }
            }
        }
    }
}

export { messages }